var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscovercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 72,
    viewBox: "0 0 99 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1567_28468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7 3H3.3C1.47746 3 0 4.47746 0 6.3V65.7C0 67.5225 1.47746 69 3.3 69H95.7C97.5225 69 99 67.5225 99 65.7V6.3C99 4.47746 97.5225 3 95.7 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9248 69H95.7015C97.5231 69 98.9998 67.524 98.9998 65.6964V42.6C98.9998 42.6 72.4856 60.8377 23.9248 69Z",
    fill: "#E7792B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2976 30.9365C93.2976 28.3379 91.4826 26.8385 88.3187 26.8385H84.249V40.7188H86.9905V35.1428H87.3485L91.1468 40.7188H94.5211L90.0917 34.8709C92.1591 34.4565 93.2976 33.0616 93.2976 30.9365ZM87.7916 33.229H86.9905V29.0248H87.8353C89.5439 29.0248 90.4736 29.7315 90.4736 31.0818C90.4736 32.4777 89.5439 33.229 87.7916 33.229Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6494 40.7188H82.4322V38.3689H77.3915V34.6221H82.2463V32.2712H77.3915V29.1905H82.4322V26.8385H74.6494V40.7188Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6334 36.1617L62.8819 26.8385H59.8838L65.8545 41.0748H67.3307L73.4084 26.8385H70.4337L66.6334 36.1617Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3096 41.5438C57.5121 41.5438 60.9191 38.1825 60.9191 34.0363C60.9191 29.89 57.5121 26.5288 53.3096 26.5288C49.107 26.5288 45.7002 29.89 45.7002 34.0363C45.7002 38.1825 49.107 41.5438 53.3096 41.5438Z",
    fill: "url(#paint0_radial_1567_28468)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0088 33.7882C34.0088 37.868 37.2559 41.0313 41.4345 41.0313C42.6156 41.0313 43.6271 40.8024 44.875 40.2226V37.0357C43.7777 38.119 42.8064 38.556 41.5622 38.556C38.7984 38.556 36.8368 36.5789 36.8368 33.7678C36.8368 31.1032 38.8604 29.0011 41.4345 29.0011C42.7433 29.0011 43.7342 29.4617 44.875 30.5626V27.3773C43.6706 26.7746 42.6798 26.5247 41.4992 26.5247C37.3418 26.5247 34.0088 29.7524 34.0088 33.7882Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0966 32.1649C27.4497 31.5638 26.9665 31.167 26.9665 30.4173C26.9665 29.5427 27.828 28.8788 29.0107 28.8788C29.8331 28.8788 30.5087 29.2118 31.2234 30.0028L32.6594 28.1479C31.4794 27.1295 30.0679 26.6089 28.5254 26.6089C26.036 26.6089 24.1374 28.3142 24.1374 30.5862C24.1374 32.4985 25.0217 33.4772 27.5986 34.3925C28.6732 34.7663 29.2199 35.0151 29.496 35.1829C30.0439 35.5364 30.3184 36.0362 30.3184 36.619C30.3184 37.7436 29.4124 38.5769 28.1878 38.5769C26.879 38.5769 25.825 37.9313 25.1929 36.7258L23.4199 38.4101C24.6842 40.2409 26.2028 41.0522 28.2911 41.0522C31.1424 41.0522 33.1431 39.1818 33.1431 36.4946C33.1431 34.2896 32.2181 33.2911 29.0966 32.1649Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6426 26.8385H22.3869V40.7188H19.6426V26.8385Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8279 26.8385H6.7998V40.7188H10.8067C12.9373 40.7188 14.4755 40.2227 15.8262 39.1165C17.4313 37.8059 18.3802 35.8308 18.3802 33.7882C18.3802 29.6918 15.2783 26.8385 10.8279 26.8385ZM14.0337 37.2653C13.171 38.0338 12.0514 38.3689 10.2784 38.3689H9.54194V29.1905H10.2784C12.0514 29.1905 13.1271 29.5031 14.0337 30.3128C14.9826 31.1467 15.5534 32.4385 15.5534 33.7678C15.5534 35.1005 14.9826 36.4319 14.0337 37.2653Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0482 27.3602C95.0482 27.1173 94.8791 26.9838 94.5804 26.9838H94.1836V28.2037H94.4789V27.7307L94.8246 28.2037H95.1851L94.7784 27.7007C94.9525 27.6546 95.0482 27.5297 95.0482 27.3602ZM94.5284 27.5269H94.4789V27.2079H94.5317C94.6778 27.2079 94.7537 27.2599 94.7537 27.3645C94.7537 27.4728 94.6769 27.5269 94.5284 27.5269Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6401 26.528C94.0395 26.528 93.5635 27.0009 93.5635 27.5914C93.5635 28.1817 94.0453 28.6553 94.6401 28.6553C95.225 28.6553 95.7043 28.177 95.7043 27.5914C95.7043 27.009 95.225 26.528 94.6401 26.528ZM94.636 28.4655C94.1641 28.4655 93.7771 28.0772 93.7771 27.5929C93.7771 27.1071 94.1591 26.7194 94.636 26.7194C95.1062 26.7194 95.4899 27.1163 95.4899 27.5929C95.4899 28.0729 95.1062 28.4655 94.636 28.4655Z",
    fill: "#1A1918"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1567_28468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9874 39.3001) rotate(-142.431) scale(13.531 13.3498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210082,
    stopColor: "#F39501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908163,
    stopColor: "#CE3C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4420A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1567_28468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 66,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovercard);
export default __webpack_public_path__ + "static/media/discovercard.adc75cd188256f75b2c32ccc29f23877.svg";
export { ForwardRef as ReactComponent };